import { defineStore } from 'pinia'

export const useLoaderStore = defineStore('loader', {
  state: () => ({
    loading: false,
    messages: [],
    currentIndex: 0,
    intervalId: null,
    timeoutId: null
  }),
  
  getters: {
    currentMessage: (state) => state.messages[state.currentIndex] || 'Loading...'
  },

  actions: {
    /** @param {string | string[]} [messages] @param {boolean} [showDelayMessage] */
    show(messages = ['Loading...'], showDelayMessage = false) {
      this.loading = true
      this.messages = Array.isArray(messages) ? messages : [messages]
      this.currentIndex = 0
      
      if (this.messages.length > 1) {
        this.startMessageRotation()
      }
      this.startLongProcessTimer(showDelayMessage)
    },

    hide() {
      this.loading = false
      this.stopMessageRotation()
      this.stopLongProcessTimer()
    },

    startMessageRotation() {
      this.stopMessageRotation()
      this.intervalId = setInterval(() => {
        if (this.currentIndex < this.messages.length - 1) {
          this.currentIndex++
        } else {
          this.stopMessageRotation()
        }
      }, 3000) 
    },

    startLongProcessTimer(showDelayMessage) {
      this.stopLongProcessTimer()
      this.timeoutId = setTimeout(() => {
        if (this.loading && showDelayMessage) {
             this.messages = ["Kindly wait... It's taking longer than normal"]
             this.currentIndex = 0
             this.stopMessageRotation()
        }
      }, 15000) 
    },

    stopMessageRotation() {
      if (this.intervalId) {
        clearInterval(this.intervalId)
        this.intervalId = null
      }
    },

    stopLongProcessTimer() {
      if (this.timeoutId) {
        clearTimeout(this.timeoutId)
        this.timeoutId = null
      }
    }
  }
})
